import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../styles/colors';

const useStyles = makeStyles({
  iconButton: {
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
});

export default useStyles;
